import React, { useState } from "react";
import { handleDangerVisible, validateEmail } from "../../global/Utils";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword } from "../../Actions/LoginAction";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const isPasswordForgeting = useSelector(
    (state) => state?.LoginReducer?.isPasswordForgeting,
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setError(false);
      setHelperText("");
      return;
    }

    if (validateEmail(value)) {
      setError(false);
      setHelperText("");
    } else {
      setError(true);
      setHelperText("Please enter a valid email address");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setError(true);
      setHelperText("Email is required");
      return;
    }

    dispatch(forgetPassword({ email: email }, navigate, handleDangerVisible));
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6">
        <div className="text-center mb-6">
          <h1 className="text-xl font-bold text-gray-800">
            Ebeaconsofts Digital Invoicing
          </h1>
          <p className="text-sm text-gray-500">
            <a
              href="https://ebeaconsofts.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer hover:underline"
            >
              EBEACONSOFTS SMC PVT LTD
            </a>
          </p>
        </div>
        <h2 className="text-lg font-semibold text-gray-700 text-center mb-4">
          Forgot Password
        </h2>
        <form onSubmit={handleSubmit}>
          <label className="text-sm font-medium text-gray-700 block">
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="example@email.com"
            className={`mt-1 w-full px-3 py-2 rounded-md border 
              ${error ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-[#3A80FB]"} 
              focus:outline-none focus:ring-2`}
          />
          {helperText && (
            <p className="text-red-500 text-sm mt-1">{helperText}</p>
          )}
          <button
            type="submit"
            disabled={isPasswordForgeting || error || !email}
            className={`mt-4 w-full py-2 rounded-md text-white transition
              ${
                isPasswordForgeting || error || !email
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#3A80FB] hover:bg-blue-600"
              }`}
          >
            {isPasswordForgeting ? "Sending..." : "Send Code"}
          </button>
        </form>
        <div className="text-center mt-4">
          <button
            onClick={() => navigate("/login")}
            className="text-sm text-[#3A80FB] hover:underline"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
